<div *ngIf="visible" class="global-spinner-container">
  <mat-progress-spinner mode="indeterminate" [diameter]="diameter" [strokeWidth]="strokeWidth" color="primary">
  </mat-progress-spinner>
</div>